import {useMutation} from '@tanstack/react-query';
import {postInvoicesRecover} from '../../services/postInvoicesRecover';

const usePostInvoicesRecoverMutation = () =>
	useMutation({
		mutationFn: postInvoicesRecover,
	});

export {usePostInvoicesRecoverMutation};
